import clsx from 'clsx'
import { Text, Icon } from 'components/common'
import { colors } from 'lib/colors'

export interface PaymentStatusIconProps {
  color?: string
  status: string
}

export const PaymentStatusIcon = ({
  color,
  status,
}: PaymentStatusIconProps): JSX.Element => {
  let title: JSX.Element
  let icon: JSX.Element
  if (status === 'FAILURE') {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        支払い不備
      </Text>
    )
    icon = (
      <Icon.ExclamationCircleTwoTone
        twoToneColor={color ? color : colors.BENIHI}
        style={{ fontSize: '16px' }}
      />
    )
  } else if (status === 'COMPLETE') {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        支払い完了
      </Text>
    )
    icon = (
      <Icon.CheckCircleTwoTone
        twoToneColor={color ? color : colors.NAE}
        style={{ fontSize: '16px' }}
      />
    )
  } else if (status === 'WAIT') {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        支払い待ち
      </Text>
    )
    icon = (
      <Icon.InfoCircleTwoTone
        twoToneColor={color ? color : colors.KUCHINASHI}
        style={{ fontSize: '16px' }}
      />
    )
  } else {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        支払い待ち
      </Text>
    )
    icon = (
      <Icon.InfoCircleTwoTone
        twoToneColor={color ? color : colors.KUCHINASHI}
        style={{ fontSize: '16px' }}
      />
    )
  }
  return (
    <>
      <div className={clsx('flex', 'flex-initial', 'items-center')}>{icon}</div>
      <div className={clsx('flex-auto', 'ml-3')}>{title}</div>
    </>
  )
}
